import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "~/lib/utils"

const iconVariants = cva("h-icon", {
  variants: {
    variant: {
      regular: "far",
      solid: "fas",
      brand: "fab",
      light: "fal",
      custom: "fak",
    },
    size: {
      xs: "h-icon--xs",
      sm: "h-icon--sm",
      md: "h-icon--md",
      xl: "h-icon--xl",
    },
    opticalCorrection: {
      true: "h-icon--optical-correction",
    },
  },
  defaultVariants: {
    variant: "regular",
    size: null,
    opticalCorrection: false,
  },
})

interface IconProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof iconVariants> {
  icon?: string
  loading?: boolean
}

function Icon({
  className,
  variant,
  size,
  opticalCorrection,
  icon,
  loading = false,
  ...props
}: IconProps) {
  const displayIcon = loading ? "spinner-third" : icon
  const displayVariant = loading ? undefined : variant
  const displayClassName = loading ? cn("fa-spin", className) : className

  return (
    <span
      aria-hidden="true"
      className={cn(
        iconVariants({ variant: displayVariant, size, opticalCorrection }),
        displayVariant ? "" : "far",
        displayIcon && `fa-${displayIcon}`,
        displayClassName,
      )}
      {...props}
    />
  )
}

export { Icon }
